import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getNeutralColors } from '../theme';
import { getColor } from '../../core/themev3';

const BasicButton = styled.a`
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  height: 40px;
  line-height: 41px;
  margin-right: 15px;
  outline: 0;
  padding: 0px 12px;
  position: relative;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  ${() => css`
    &.solidButton {
      background-color: ${getColor('primary')};
      color: ${getNeutralColors('white')};
      max-width: 100%;
      font-weight: 600;
      &:hover {
        background-color: ${getColor('secondary')};
      }
      &.active {
        background-color: ${getColor('secondary')};
      }
    }
    &.borderButton {
      background-color: ${getNeutralColors('white')};
      color: ${getNeutralColors('black')};
      border: 1px solid ${getColor('primary')};
      max-width: 100%;
      &:hover {
        border-color: ${getColor('secondary')};
        background-color: ${getColor('tertiary')};
      }
    }
    &.noBorderButton {
      background-color: ${getNeutralColors('white')};
      color: ${getNeutralColors('black')};
      max-width: 100%;
      font-weight: 500;
      &:hover {
        background-color: ${getNeutralColors('grisClaroIII')};
      }
    }
  `}

  ${({ header }) =>
    header &&
    css`
      margin: 0 8px;
    `}

  @media ${({ theme }) => theme.v2.breakpoints.MinAndMax.tablet} {
    font-size: 1.6rem;
    line-height: 48px;
    margin-bottom: 11px;
    margin-right: 0px;
    min-height: 48px;
  }

  @media ${({ theme }) => theme.v2.breakpoints.MinAndMax.mobile} {
    font-size: 1.6rem;
    line-height: 48px;
    margin-bottom: 11px;
    margin-right: 0px;
    min-height: 48px;
  }
`;

function Button(props) {
  const {
    buttonType,
    linkRef,
    dataPanel,
    onClick,
    hrefDisabled,
    idTourReputationLevel,
    text = '',
    target = '',
    header = false
  } = props;
  return (
    <BasicButton
      href={!hrefDisabled ? linkRef : null}
      onClick={onClick}
      className={buttonType}
      data-panel={dataPanel}
      target={target || '_self'}
      header={header}
      data-tour-panel={idTourReputationLevel}
    >
      {text}
    </BasicButton>
  );
}

Button.propTypes = {
  buttonType: PropTypes.string.isRequired,
  linkRef: PropTypes.string.isRequired,
  dataPanel: PropTypes.string.isRequired
};

export { Button };
